<template>
  <div>
    <b-row class="border-bottom m-2 pb-2">
      <b-col md="2" class="font-weight-bold"
        >Full Kit ({{ is_n_of }} of {{ of_total }})</b-col
      >
      <b-col md="2"
        ><img
          width="80"
          src="https://dashboard.icap-maker.com/img/shipping/bigbox.jpg"
      /></b-col>
      <b-col md="2"
        ><img
          width="80"
          src="https://dashboard.icap-maker.com/img/shipping/cap.jpg"
      /></b-col>
      <b-col md="2"
        ><img
          width="80"
          src="https://dashboard.icap-maker.com/img/shipping/stickers.jpg"
      /></b-col>
      <b-col md="2"
        ><img
          width="80"
          src="https://dashboard.icap-maker.com/img/shipping/notecard.jpg"
      /></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    is_n_of: { type: Number },
    of_total: { type: Number }
  }
};
</script>

<style lang="scss" scoped></style>
